import { render } from "./AppSkeleton.vue?vue&type=template&id=56a82ec7&scoped=true"
import script from "./AppSkeleton.vue?vue&type=script&lang=js"
export * from "./AppSkeleton.vue?vue&type=script&lang=js"

import "./AppSkeleton.vue?vue&type=style&index=0&id=56a82ec7&lang=less&scoped=true"

import exportComponent from "/Users/liuhaitao/ij_project/patent_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a82ec7"]])

export default __exports__